import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { LoadingState } from '@asad/crane-ui'

import { useAppSelector } from '@/hooks/reduxHooks'

import { useConsentBootstrap } from '../hooks/useConsentBootstrap'

export type RequireConsentProps = {
  children: React.ReactNode
}

export const isRestorablePath = (path: unknown): path is string =>
  typeof path === 'string' &&
  path.startsWith('/') &&
  !path.startsWith('/auth') &&
  !path.startsWith('/consent') &&
  !path.startsWith('/logout')

export const ConsentScreen = ({ children }: { children: React.ReactNode }) => (
  <div className='crane-ui-surface flex min-h-screen items-center justify-center bg-crane-background text-crane-foreground'>
    {children}
  </div>
)

export const RequireConsent = ({ children }: RequireConsentProps) => {
  const { pathname, search } = useLocation()

  const { state: bootstrap } = useConsentBootstrap()

  const roles = useAppSelector((state) => state.profile?.data?.role || [])
  const consentRequired = useAppSelector((state) => state.auth.consentRequired)
  const activeRodoPolicy = useAppSelector((state) => state.rodoPoliciesDocuments.activeDocument)
  const activeDataProcessing = useAppSelector((state) => state.dataProcessingConsents.activeDocument)

  if (bootstrap === 'broken-session') return <Navigate to='/auth/login' replace />

  if (bootstrap === 'pending') {
    return (
      <ConsentScreen>
        <LoadingState />
      </ConsentScreen>
    )
  }

  /* Publikacja dokumentu cofa zgody wszystkim, także administratorowi RODO — objęty
     bramką zablokowałby sam sobie moduł, w którym musi dokończyć publikację. */
  if (roles.includes('ADMIN_RODO')) return <>{children}</>

  const blocked = bootstrap === 'failed' || (consentRequired && Boolean(activeRodoPolicy && activeDataProcessing))

  if (blocked) {
    const from = `${pathname}${search}`

    return <Navigate to='/consent' replace state={{ from: isRestorablePath(from) ? from : '/' }} />
  }

  return <>{children}</>
}
